import Home from "./home";


if (document.body.getAttribute("data-current-path") === "pages") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "home") {
        new Home();
    }
}